import { ChevronDown } from 'lucide-react';
import { ReactNode } from 'react';

export function Select(props: { children: ReactNode, value: string | ReactNode, label: string, disabled?: boolean, minWidth?: string, neutral?: boolean, minHeight?: string }) {
  const { children, value, label, disabled, minWidth, neutral, minHeight } = props;

  const defaultMinWidth = minWidth ?? '150px';
  const defaultMinHeight = minHeight ?? '0px';

  // min-w-0 lets the wrapper shrink inside a flex row so the selected value
  // can truncate instead of forcing the button to the full width of a long value.
  return (
    <div className="mw-100 min-w-0">
      <button
        className={`fusa-menu-btn-neutral ${neutral ? '' : 'bg-body-secondary text-black'} d-flex align-items-center justify-content-between mw-100`}
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label={label}
        style={{ minWidth: defaultMinWidth, minHeight: defaultMinHeight }}
        disabled={disabled}
        >
        <div className='pe-3 text-truncate' data-testid="selected-value">{value}</div>
        <ChevronDown size={16} color="var(--neutral-600)" className="flex-shrink-0" />
      </button>
      <ul className="dropdown-menu overflow-y-auto beat-sticky-top fusa-menu-item" style={{ maxHeight: '250px', minWidth: defaultMinWidth, maxWidth: 'min(90vw, 40rem)' }}>
        {children}
      </ul>
    </div>
  );
}
